import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
axios.defaults.withCredentials = true;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("bs_token"));
  const [loading, setLoading] = useState(true);

  const fetchMe = async (jwt) => {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const { data } = await axios.get(`${API}/auth/me`, { headers, withCredentials: true });
    return data;
  };

  useEffect(() => {
    // CRITICAL: If returning from Emergent OAuth callback, skip /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    fetchMe(token)
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem("bs_token"); setToken(null); setUser(null); })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("bs_token", data.token);
    setToken(data.token); setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    localStorage.setItem("bs_token", data.token);
    setToken(data.token); setUser(data.user);
    return data.user;
  };
  const exchangeSession = async (session_id) => {
    const { data } = await axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch {}
    localStorage.removeItem("bs_token");
    setToken(null); setUser(null);
  };

  const refreshUser = async () => {
    const u = await fetchMe(token);
    setUser(u);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, exchangeSession, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const apiClient = () => {
  const token = localStorage.getItem("bs_token");
  const instance = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  // Trial expired → soft redirect to subscription
  instance.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 402 && typeof window !== "undefined") {
        if (!window.location.pathname.endsWith("/subscription")) {
          window.location.href = "/app/subscription?trial_expired=1";
        }
      }
      return Promise.reject(err);
    }
  );
  return instance;
};
